<div class="left-side">
  <div class="text-column">
    <p class="tag">{{ 'onboarding.stepTwo.tag' | translate }}</p>
    <p class="title">{{ 'onboarding.stepTwo.title' | translate }}</p>

    <div class="cards">
      <app-onboarding-info-card badgeColor="pink">
        <span slot="badge">1</span>
        <span slot="title">{{ 'onboarding.stepTwo.cards.step1.title' | translate }}</span>
        <span slot="description">{{ 'onboarding.stepTwo.cards.step1.description' | translate }}</span>
      </app-onboarding-info-card>
      <app-onboarding-info-card badgeColor="green">
        <span slot="badge">2</span>
        <span slot="title">{{ 'onboarding.stepTwo.cards.step2.title' | translate }}</span>
        <span slot="description">{{ 'onboarding.stepTwo.cards.step2.description' | translate }}</span>
      </app-onboarding-info-card>
      <app-onboarding-info-card badgeColor="purple">
        <span slot="badge">3</span>
        <span slot="title">{{ 'onboarding.stepTwo.cards.step3.title' | translate }}</span>
        <span slot="description">{{ 'onboarding.stepTwo.cards.step3.description' | translate }}</span>
      </app-onboarding-info-card>
    </div>
  </div>
</div>
<div class="right-side">
  <img
    ngSrc="/images/onboarding/step-2.svg"
    width="470"
    height="408"
    [alt]="'onboarding.stepTwo.imageAlt' | translate"
  />
</div>
